import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as departmentApi from "../../api/departmentApi/departmentApi";
import {EQDepartment, initialDepartmentList} from "../../models/serverModels/EQDepartment";
import DepartmentForm from "./DepartmentForm";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const departmentSchema = yup.object({
  name: yup.string().required("부서명을 입력해주세요"),
});

const UpdateDepartment = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {
    data: department,
    isLoading,
    isFetching,
  } = useGetItemQuery<ResponseItem<EQDepartment>>({
    key: ["Document", id],
    api: () => departmentApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate} = useUpdateMutation<
    ResponseItem<EQDepartment>,
    Params.Update<EQDepartment>
  >({
    api: departmentApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Department`);
        queryClient.invalidateQueries("DocumentList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<EQDepartment>({
    defaultValues: initialDepartmentList,
    resolver: yupResolver(departmentSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(department?.item);
  }, [department?.item, reset]);

  const onSubmit: SubmitHandler<EQDepartment> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...department?.item, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="부서 수정" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DepartmentForm captionColor="#546E7A" />
          <ConfirmButtonGroup link={`/Department`} cancelText="취소" confirmText="수정" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default UpdateDepartment;
